import React, { useEffect, useRef, useState } from "react";

const ScrollTransformWrapper = ({ setRelativeTop,setScrollProgress,setIsVisible,
  children,
  containerId,
  maxTranslate = 300,
  maxRotate = 45,
  maxScale = 1.2,
  transition = "transform 0.1s ease-out",
  customStyleFn = null,
}) => {
  const ref = useRef(null);
  const [scrollData, setScrollData] = useState({
    scrollTop: 0,
    relativeTop: 0,
    inView: false,
  });

  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container || !ref.current) return;

    const handleScroll = () => {
      const containerRect = container.getBoundingClientRect();
      const elementRect = ref.current.getBoundingClientRect();

      const relativeTop = elementRect.top - containerRect.top;
      const relativeBottom = elementRect.bottom - containerRect.top;

 const scrollProgress = container.clientHeight - relativeTop;
 const clientHeight = container.clientHeight;
      const isVisible =
        relativeBottom > 0 && relativeTop < container.clientHeight;

      setScrollData({
        scrollTop: container.scrollTop,relativeBottom,
        relativeTop,scrollProgress,clientHeight,
        inView: isVisible,
      });
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount

    return () => container.removeEventListener("scroll", handleScroll);
  }, [containerId]);

  const { scrollTop, relativeTop,relativeBottom,clientHeight,scrollProgress, inView } = scrollData;

  // Only animate when in view
  let style = {}; let myStyles={}
  if (inView) {
    const translateY = Math.min(relativeTop * 0.3, maxTranslate);
    const rotate = Math.min(relativeTop * 0.05, maxRotate);
    const scale = Math.min(1 + relativeTop / 1000, maxScale);

    style = customStyleFn
      ? customStyleFn({ scrollTop, relativeTop,scrollProgress, translateY, rotate, scale ,myStyles })
      : {
        };
        

        setRelativeTop(relativeTop);
        setScrollProgress(scrollProgress);setIsVisible(relativeBottom > 0 && relativeTop < clientHeight?true:false);
  }

  return (
    <div ref={ref} style={{}}>
      {children} 
    </div>
  );
};

export default ScrollTransformWrapper;